import { Button, Divider, Row, Col, Space } from 'antd';
import React, { FC, useState } from 'react';
import {
  WOA_PLATFORM_LIST,
  TDS_QQ_PLATFORM_LIST,
  TEST_TDS_QQ_PLATFORM_LIST,
  DEFAULT_ICP,
  DEFAULT_ICP_URL,
  TDS_HOME_URL,
  TDS_QQHOME_URL,
  TEST_TDS_QQHOME_URL,
} from './config';
import HippySvg from './image/hippy.svg';
import KuiklySvg from './image/kuikly.svg';
import TdfHomeLogo from './image/tdf-home.svg';
import TdsHomeActiveLogo from './image/tds-home-active.svg';
import TdsHomeLogo from './image/tds-home.svg';
import TdsLiteHoverLogo from './image/tds-lite-hover.svg';
import TdsLiteLogo from './image/tds-lite.svg';
import TdsQQHomeLogo from './image/tds-qq-home.svg';
import TdsQQLiteLogo from './image/tds-qq-lite.svg';
import VectorLayoutSvg from './image/vectorLayout.svg';
import './index.scss';

interface FooterProps {
  qrcode?: string; // 二维码
  tdsLogo?: string;
  privacyPolicyUrl?: string;
  hasChildrenLogo?: boolean;
  // 是否展示产品矩阵
  showMatrixList?: boolean;
  // 备案号
  icp?: string;
  icpURL?: string;
  isTdf?: boolean;
  isProd?: boolean;
}

interface FooterLiteProps {
  privacyPolicyUrl?: string;
  // 是否是商业化
  isTdsQQ?: boolean;
  isProd?: boolean;
}

const handleOpenUrl = (src: string) => {
  if (src) {
    window.open(src);
  }
};

export const TdsFooter: FC<{
  /**
   * @description icp
   * @default 粤B2-20090059
   */
  icp?: string;
  /**
   * @description icpURL
   * @default https://beian.miit.gov.cn/#/Integrated/index
   */
  icpURL?: string;
  /**
   * @description 是否是tdf页面
   * @default false
   */
  isTdf?: boolean;
  /**
   * @description 隐私保护声明url
   * @default https://privacy.qq.com/document/preview/ca7228b56e6941638fc755edb1a497a7
   */
  privacyPolicyUrl?: string;
}> = (props) => {
  const { icp = DEFAULT_ICP, icpURL = DEFAULT_ICP_URL, isTdf } = props;
  const [active, setActive] = useState(false);
  const icpOnClick = () => {
    if (!icpURL) {
      return;
    }
    const a = document.createElement('a');
    a.href = icpURL;
    a.target = '_blank';
    a.click();
  };
  let homeSvg = TdsHomeLogo;
  if (active) {
    homeSvg = TdsHomeActiveLogo;
  }
  if (isTdf) {
    homeSvg = TdfHomeLogo;
  }

  return (
    <div className='tds-footer'>
      <div className='home-footer'>
        <Space align='center' size={28}>
          <img
            src={homeSvg}
            alt=""
            className={'home-footer-logo'}
            onClick={() => handleOpenUrl(TDS_HOME_URL)}
            onMouseEnter={() => setActive(true)}
            onMouseLeave={() => setActive(false)}
          />
          {
            isTdf ? (
              <Space size={14} align='center' className='tdf-icon'>
                <Space size={5} align='center'>
                  <img src={HippySvg} alt="" />
                  <span>Hippy</span>
                </Space>
                <Space size={5} align='center'>
                  <img src={KuiklySvg} alt="" style={{ width: '24px' }} />
                  <span>Kuikly</span>
                </Space>
                <Space size={5} align='center'>
                  <img src={VectorLayoutSvg} alt="" />
                  <span>VectorLayout</span>
                </Space>
              </Space>
            ) : null
          }
        </Space>
        <br />
        <Space className='platform' align='center'>
          <span className='platform-title'>端服务产品：</span>
          <Row gutter={20}>
            {WOA_PLATFORM_LIST.map((item, idx) => (
              <Col key={idx}>
                <Button type='link' className='platform-btn tds-btn' onClick={() => (handleOpenUrl(item.src))}>{item.title}</Button>
              </Col>
            ))}
          </Row>
        </Space>
        <Divider style={{ margin: '20px 0', background: '#4B4B4B' }} />
        <Space size={11} className='home-footer-copyright' align="center">
          <span>Copyright © 1998 - 2025 Tencent. All Rights Reserved.</span>
          <Space size={0}>
            <Button type='link' className='tds-btn tds-btn-link' onClick={() => (window.open('https://www.qq.com/contract.shtml'))}>服务协议</Button>
            <Divider type='vertical' className='divider' />
            <Button type='link' className='tds-btn tds-btn-link' onClick={() => (window.open(props?.privacyPolicyUrl || 'https://privacy.qq.com/policy/tencent-privacypolicy'))}>隐私保护声明</Button>
          </Space>
          <div className='footer-ccg-text'>腾讯公司<span className='index-footer-pcg-divider'>版权所有</span>
            <span className='footer-pcg-href' onClick={icpOnClick}>
              <span className='index-footer-pcg-divider'>主体备案号</span><span className='icp'>{icp}</span>
            </span>
          </div>
        </Space>
      </div>
    </div>
  );
};

// 内页页脚
export const TdsFooterLite: FC<FooterLiteProps> = (props) => {
  const { isTdsQQ, isProd = true } = props;
  const [active, setActive] = useState(false);

  let homeSvg = TdsLiteLogo;
  if (active) {
    homeSvg = TdsLiteHoverLogo;
  }
  if (isTdsQQ) {
    homeSvg = TdsQQLiteLogo;
  }
  let list = WOA_PLATFORM_LIST;
  if (isTdsQQ) {
    list = isProd ? TDS_QQ_PLATFORM_LIST : TEST_TDS_QQ_PLATFORM_LIST;
  }

  return (
    <div className='tds-footer-lite'>
      <Space split={<Divider type="vertical" />}>
        <Button className='copyright tds-btn' type="link">
          腾讯公司
          <span className='copyright-txt'>版权所有</span>
          <span className='footer-pcg-divider'>
            <img
              src={homeSvg}
              onClick={() => handleOpenUrl(isTdsQQ ? '' : TDS_HOME_URL)}
              onMouseEnter={() => setActive(true)}
              onMouseLeave={() => setActive(false)}
            />
          </span>
          <span className='footer-pcg-divider'>Copyright © 1998 - 2025 Tencent. All Rights Reserved.</span>
        </Button>
        <Button type='link' onClick={() => window.open(props?.privacyPolicyUrl || 'https://privacy.qq.com/document/preview/ca7228b56e6941638fc755edb1a497a7')} className='privacy tds-btn'>隐私政策</Button>
      </Space>
      <div className='pag-matrix'>
      <span style={{ lineHeight: '36px' }}>端服务产品：</span>
        {list.map((item, idx) => (
          <Button key={idx} type='link' className='platform-btn tds-btn' onClick={() => (handleOpenUrl(item.src))}>{item.title}</Button>
        ))}
      </div>
    </div>
  );
};

// 商业化页脚首页
export const TdsFooterFull: FC<FooterProps> = (props) => {
  const { icp = DEFAULT_ICP, icpURL = DEFAULT_ICP_URL, isProd = true, qrcode } = props;
  const icpOnClick = () => {
    if (!icpURL) {
      return;
    }
    const a = document.createElement('a');
    a.href = icpURL;
    a.target = '_blank';
    a.click();
  };

  return <div className={'tds-footer-full'}>
    <div className='footer-pcg-term'>
      <Row gutter={24} align='middle'>
        <Col>
          <img
            src={TdsQQHomeLogo}
            alt=""
            className='tds-footer-full-logo'
            onClick={() => handleOpenUrl(isProd ? TDS_QQHOME_URL : TEST_TDS_QQHOME_URL)}
          />
        </Col>
        {(isProd ? TDS_QQ_PLATFORM_LIST : TEST_TDS_QQ_PLATFORM_LIST).map((platform, idx) => (
          <Col key={idx} onClick={() => handleOpenUrl(platform.src)} className='tds-footer-home-qq'>{platform.title}</Col>
        ))}
        {qrcode ? <img className={'qrcode'} src={qrcode} alt=""/> : null}
      </Row>
    </div>
    <Space size={11} align='center'>
      <span>Copyright © 1998 - 2025 Tencent. All Rights Reserved.</span>
      <Space size={11}>
        <span className='footer-pcg-href'>
          <a className='footer-pcg-href-link' href='https://www.qq.com/contract.shtml' target='_blank'>服务协议</a> | <a className='footer-pcg-href-link' href={props?.privacyPolicyUrl || 'https://privacy.qq.com/policy/tencent-privacypolicy'} target='_blank'>隐私保护声明</a>
        </span>
        <span>
          腾讯公司 | 版权所有 | <span onClick={icpOnClick}>主体备案号 {icp}</span>
        </span>
      </Space>
    </Space>
  </div>;
};

// 商业化移动端页脚
export const TdsFooterFullMobile: FC<FooterProps> = (props) => {
  const { icp = DEFAULT_ICP, icpURL = DEFAULT_ICP_URL, isProd } = props;

  return (
    <div className='tds-footer-full-mobile'>
      <div className='footer-pcg-term'>
        <img src={TdsQQHomeLogo} className='tds-footer-full-mobile-logo' />
        {(isProd ? TDS_QQ_PLATFORM_LIST : TEST_TDS_QQ_PLATFORM_LIST).map((platform, idx) => (
          <a key={idx} href={platform.src} target="_blank" className='platform-title'>{platform.title}</a>
        ))}
      </div>
      <div className='footer-copyright'>
        Copyright © 1998 - 2025 Tencent. All Rights Reserved.
      </div>
      <div className='footer-links'>
        <a href="https://www.qq.com/contract.shtml" target="_blank">服务协议</a>
        <a href={props?.privacyPolicyUrl || 'https://privacy.qq.com/policy/tencent-privacypolicy'} target="_blank">服务协议</a>
        <span className='footer-ccg'>
          <span>腾讯公司<Divider type='vertical' className='divider' />版权所有</span>
          <Divider type='vertical' className='divider' />
          <a href={icpURL} target="_blank">
            主体备案号 {icp}
          </a>
        </span>
      </div>
    </div>
  );
};
